// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__oc0Q7","footer":"ModalFilter_footer__1LXvu"};